// extracted by mini-css-extract-plugin
export default {"legend":"zra-z","legendSpacing":"Ara-z"};